import React from 'react';

// Import all presidents
import { georgeWashington } from './georgeWashington.jsx';
import { johnAdams } from './johnAdams.jsx';
import { thomasJefferson } from './thomasJefferson.jsx';
import { jamesMadison } from './jamesMadison.jsx';
import { jamesMonroe } from './jamesMonroe.jsx';
import { johnQuincyAdams } from './johnQuincyAdams.jsx';
import { andrewJackson } from './andrewJackson.jsx';
import { martinVanBuren } from './martinVanBuren.jsx';
import { williamHenryHarrison } from './williamHenryHarrison.jsx';
import { johnTyler } from './johnTyler.jsx';
import { jamesKPolk } from './jamesKPolk.jsx';
import { zacharyTaylor } from './zacharyTaylor.jsx';
import { millardFillmore } from './millardFillmore.jsx';
import { franklinPierce } from './franklinPierce.jsx';
import { jamesBuchanan } from './jamesBuchanan.jsx';
import { abrahamLincoln } from './abrahamLincoln.jsx';
import { andrewJohnson } from './andrewJohnson.jsx';
import { ulyssesSGrant } from './ulyssesSGrant.jsx';
import { rutherfordBHayes } from './rutherfordBHayes.jsx';
import { jamesAGarfield } from './jamesAGarfield.jsx';
import { chesterAArthur } from './chesterAArthur.jsx';
import { groverCleveland } from './groverCleveland.jsx';
import { benjaminHarrison } from './benjaminHarrison.jsx';
import { groverCleveland2 } from './groverCleveland2.jsx';
import { williamMcKinley } from './williamMcKinley.jsx';
import { theodoreRoosevelt } from './theodoreRoosevelt.jsx';
import { williamHowardTaft } from './williamHowardTaft.jsx';
import { woodrowWilson } from './woodrowWilson.jsx';
import { warrenGHarding } from './warrenGHarding.jsx';
import { calvinCoolidge } from './calvinCoolidge.jsx';
import { herbertHoover } from './herbertHoover.jsx';
import { franklinDRoosevelt } from './franklinDRoosevelt.jsx';
import { harrySTruman } from './harrySTruman.jsx';
import { dwightDEisenhower } from './dwightDEisenhower.jsx';
import { johnFKennedy } from './johnFKennedy.jsx';
import { lyndonBJohnson } from './lyndonBJohnson.jsx';
import { richardNixon } from './richardNixon.jsx';
import { geraldFord } from './geraldFord.jsx';
import { jimmyCarter } from './jimmyCarter.jsx';
import { ronaldReagan } from './ronaldReagan.jsx';
import { georgeHWBush } from './georgeHWBush.jsx';
import { billClinton } from './billClinton.jsx';
import { georgeWBush } from './georgeWBush.jsx';
import { barackObama } from './barackObama.jsx';
import { donaldTrump } from './donaldTrump.jsx';
import { joeBiden } from './joeBiden.jsx';

// Create presidents array
export const allPresidents = [
  georgeWashington,
  johnAdams,
  thomasJefferson,
  jamesMadison,
  jamesMonroe,
  johnQuincyAdams,
  andrewJackson,
  martinVanBuren,
  williamHenryHarrison,
  johnTyler,
  jamesKPolk,
  zacharyTaylor,
  millardFillmore,
  franklinPierce,
  jamesBuchanan,
  abrahamLincoln,
  andrewJohnson,
  ulyssesSGrant,
  rutherfordBHayes,
  jamesAGarfield,
  chesterAArthur,
  groverCleveland,
  benjaminHarrison,
  groverCleveland2,
  williamMcKinley,
  theodoreRoosevelt,
  williamHowardTaft,
  woodrowWilson,
  warrenGHarding,
  calvinCoolidge,
  herbertHoover,
  franklinDRoosevelt,
  harrySTruman,
  dwightDEisenhower,
  johnFKennedy,
  lyndonBJohnson,
  richardNixon,
  geraldFord,
  jimmyCarter,
  ronaldReagan,
  georgeHWBush,
  billClinton,
  georgeWBush,
  barackObama,
  donaldTrump,
  joeBiden
];

// Export individual presidents for direct access
export {
  georgeWashington,
  johnAdams,
  thomasJefferson,
  jamesMadison,
  jamesMonroe,
  johnQuincyAdams,
  andrewJackson,
  martinVanBuren,
  williamHenryHarrison,
  johnTyler,
  jamesKPolk,
  zacharyTaylor,
  millardFillmore,
  franklinPierce,
  jamesBuchanan,
  abrahamLincoln,
  andrewJohnson,
  ulyssesSGrant,
  rutherfordBHayes,
  jamesAGarfield,
  chesterAArthur,
  groverCleveland,
  benjaminHarrison,
  groverCleveland2,
  williamMcKinley,
  theodoreRoosevelt,
  williamHowardTaft,
  woodrowWilson,
  warrenGHarding,
  calvinCoolidge,
  herbertHoover,
  franklinDRoosevelt,
  harrySTruman,
  dwightDEisenhower,
  johnFKennedy,
  lyndonBJohnson,
  richardNixon,
  geraldFord,
  jimmyCarter,
  ronaldReagan,
  georgeHWBush,
  billClinton,
  georgeWBush,
  barackObama,
  donaldTrump,
  joeBiden
};